import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.splice";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { deepClone } from '@/utils/index';
var timer = null;

var SliderText = /*#__PURE__*/function (_Vue) {
  _inherits(SliderText, _Vue);

  var _super = _createSuper(SliderText);

  function SliderText() {
    var _this;

    _classCallCheck(this, SliderText);

    _this = _super.apply(this, arguments);
    _this.isShow = false;
    _this.showList = [];
    return _this;
  }

  _createClass(SliderText, [{
    key: "getShowList",
    value: function getShowList(val) {
      this.showList = deepClone(val) || [];

      if (this.showList.length) {
        this.isShow = true;
      }
    }
  }, {
    key: "setTimer",
    value: function setTimer() {
      var _this2 = this;

      if (timer) {
        clearInterval(timer);
        timer = null;
      }

      timer = setInterval(function () {
        if (_this2.showList.length > 1) {
          var textObject = _this2.showList.splice(0, 1);

          _this2.showList = _this2.showList.concat(textObject);
        }
      }, 5000);
      this.$on('hook:beforeDestroy', function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      });
    }
  }, {
    key: "closeSlider",
    value: function closeSlider() {
      this.isShow = false;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.setTimer();
    }
  }]);

  return SliderText;
}(Vue);

__decorate([Prop({
  required: true
})], SliderText.prototype, "list", void 0);

__decorate([Watch('list')], SliderText.prototype, "getShowList", null);

SliderText = __decorate([Component], SliderText);
export default SliderText;